
import { LANGUAGES } from '@/applicationDefinition/droplistData/languages'
import { MARITAL } from '@/applicationDefinition/droplistData/maritalStatus'
import { COUNTYEA } from '@/applicationDefinition/droplistData/countyEA'
import { SERVICES } from '@/applicationDefinition/droplistData/services'
import store from '@/store/store'
import { REFDATA_MAP } from '@/constants'


// dataRaw - original array to be map
// dataList - reference data to be retrieve
// dataAttribute - matching attribute for the list
// dataTest - attribute value to check against
// dataResult - attribute value to return
const CheckArrayHasValue = (
  dataRaw,
  dataList,
  dataTest,
  dataAttribute,
  dataResult
) => {
  // sanity check first
  if (!dataAttribute) {
    dataAttribute = 'value'
  }
  if (!dataResult) {
    dataResult = 'text'
  }
  if (dataRaw) {
    dataRaw = dataRaw.map(item => {
      // make sure item is not null and that dataTest resolves
      if (
        item &&
        item != undefined &&
        item[dataTest] &&
        item[dataTest] != undefined
      ) {
        item[dataTest + 'Print'] = CheckAttributeHasValue(
          dataList,
          item[dataTest],
          dataAttribute,
          dataResult
        )
      }
      return item
    })
  }

  return dataRaw
}

// dataRaw - original array to be map
// dataList - reference data to be retrieve
// dataAttribute - matching attribute for the list
// dataTest - attribute value to check against
// dataResult - attribute value Array to return
const CheckArrayMapValueArray = (dataRaw, dataList) => {
  if (dataRaw) {
    var data = dataRaw.map(item => {
      if (item) {
        item = CheckAttributeHasValue(dataList, item)
      }
      return item
    })
    return data
  } else {
    return dataRaw
  }
}

// compares .text and returns .value by default
const CheckAttributeHasValue = (
  dataList,
  dataTest,
  dataAttribute,
  dataResult
) => {
  // sanity check first
  if (!dataAttribute) {
    dataAttribute = 'value'
  }
  if (!dataResult) {
    dataResult = 'text'
  }
  if (dataList) {
    const dataPrint = dataList.find(item => item[dataAttribute] === dataTest)
    if (dataPrint) {
      return dataPrint[dataResult]
    }
  }
}

export default userData => {
  /*
    Server-side PDF generation cannot perform lookups on codes, so
    any fields that use codes (e.g. droplists) need to set a "print"
    value containing the display text. E.G.
   
  */

  // get reference data from store
  let refData = store.state.refData

   
  userData.client.primaryLanguagePrint = CheckAttributeHasValue(LANGUAGES, userData.client.primaryLanguage)
  userData.client.maritalStatusPrint = CheckAttributeHasValue(MARITAL, userData.client.maritalStatus)
  userData.general.otherCountyEA.otherCountyPrint = CheckAttributeHasValue(COUNTYEA, userData.general.otherCountyEA.otherCounty)
  userData.services.typePrint = CheckArrayMapValueArray(userData.services.type, SERVICES )
 
  return userData
}
